module.exports = __webpack_public_path__ + "img/lawbot-hd.5efa9a27.png";